import { render } from "./myDoctors.vue?vue&type=template&id=b179beba&scoped=true"
import script from "./myDoctors.vue?vue&type=script&lang=js"
export * from "./myDoctors.vue?vue&type=script&lang=js"

import "./myDoctors.vue?vue&type=style&index=0&id=b179beba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b179beba"]])

export default __exports__